export default {
    createEvent: '/events/create',
    createPaidHit: '/events/create-paid-hit',
    createPlay: '/events/create-play',
    createTournament: '/create-event',
    education: '/education',
    explore: '/explore',
    forCollegeCoaches: '/for-college-coaches',
    forHighSchoolCoaches: '/for-high-school-coaches',
    forOrganizations: '/for-organizations',
    getRated: '/getrated',
    home: '/home',
    inbox: '/inbox',
    join: '/join',
    login: '/login',
    offerPaidHit: '/offer-paid-hit',
    postScoreSelect: '/post-score-select',
    powerPerks: '/power-perks',
    searchEvents: '/search?sportTypes=tennis,pickleball&type=events',
    searchPlayers: '/search?sportTypes=tennis,pickleball&type=players',
    collegeCorner: '/college-corner',
};
